import { render } from "./UserPhoto.vue?vue&type=template&id=33f4459d&scoped=true"
import script from "./UserPhoto.vue?vue&type=script&lang=js"
export * from "./UserPhoto.vue?vue&type=script&lang=js"

import "./UserPhoto.vue?vue&type=style&index=0&id=33f4459d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f4459d"]])

export default __exports__